<div class="grid">
    <!-- SIDEBAR COM LISTA DE XMLs -->
    <div class="col-12 md:col-3">
        <p-card header="XMLs Processados">
            <div class="flex flex-column gap-2">
                <div *ngFor="let xml of xmlsProcessados" 
                     class="p-3 border-round cursor-pointer hover:surface-hover"
                     [ngClass]="{'surface-200': xmlSelecionado?.arquivo === xml.arquivo}"
                     (click)="selecionarXml(xml)">
                    <div class="flex align-items-center gap-2">
                        <i class="pi pi-file text-primary"></i>
                        <div class="flex-1">
                            <p class="m-0 font-semibold text-sm">{{xml.arquivo}}</p>
                            <p class="m-0 text-xs text-500">{{xml.itens.length}} itens</p>
                        </div>
                        <i class="pi pi-chevron-right text-500"></i>
                    </div>
                </div>
            </div>
        </p-card>
    </div>
    
    <!-- CONTEÚDO DO XML SELECIONADO -->
    <div class="col-12 md:col-9">
        <p-tabView [(activeIndex)]="activeIndex" *ngIf="xmlSelecionado">
            <!-- ABA 1: CABEÇALHO -->
            <p-tabPanel header="Cabeçalho DUIMP" leftIcon="pi pi-file-o">
                <p-card>
                    <h5 class="mb-4">{{xmlSelecionado.arquivo}}</h5>
                    
                    <div class="grid">
                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="field">
                                <label class="font-semibold text-sm">Número DUIMP:</label>
                                <p class="mt-1 font-mono">{{xmlSelecionado.cabecalho?.numeroDuimp || '-'}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="field">
                                <label class="font-semibold text-sm">Data DUIMP:</label>
                                <p class="mt-1">{{xmlSelecionado.cabecalho?.dataDuimp || '-'}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="field">
                                <label class="font-semibold text-sm">Data XML:</label>
                                <p class="mt-1">{{xmlSelecionado.cabecalho?.dataXml || '-'}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="field">
                                <label class="font-semibold text-sm">UF Desembaraço:</label>
                                <p class="mt-1">{{xmlSelecionado.cabecalho?.ufDesembaraco || '-'}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="field">
                                <label class="font-semibold text-sm">Local Desembaraço:</label>
                                <p class="mt-1">{{xmlSelecionado.cabecalho?.localDesembaraco || '-'}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="field">
                                <label class="font-semibold text-sm">Cotação Dólar:</label>
                                <p class="mt-1">R$ {{formatarValor(xmlSelecionado.cabecalho?.cotacaoDolar)}}</p>
                            </div>
                        </div>
                    </div>
                    
                    <p-divider></p-divider>
                    
                    <h6>Valores e Impostos</h6>
                    
                    <div class="grid">
                        <div class="col-12 md:col-6 lg:col-3">
                            <div class="field">
                                <label class="font-semibold text-sm">Total (Dólar):</label>
                                <p class="mt-1 text-primary font-bold">$ {{formatarValor(xmlSelecionado.cabecalho?.totalMateriaisDolar)}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-3">
                            <div class="field">
                                <label class="font-semibold text-sm">Total (Reais):</label>
                                <p class="mt-1 text-primary font-bold">R$ {{formatarValor(xmlSelecionado.cabecalho?.totalMateriaisReais)}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-3">
                            <div class="field">
                                <label class="font-semibold text-sm">Frete:</label>
                                <p class="mt-1">R$ {{formatarValor(xmlSelecionado.cabecalho?.frete)}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-3">
                            <div class="field">
                                <label class="font-semibold text-sm">Seguro:</label>
                                <p class="mt-1">R$ {{formatarValor(xmlSelecionado.cabecalho?.seguro)}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-3">
                            <div class="field">
                                <label class="font-semibold text-sm">IPI:</label>
                                <p class="mt-1">R$ {{formatarValor(xmlSelecionado.cabecalho?.ipi)}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-3">
                            <div class="field">
                                <label class="font-semibold text-sm">PIS:</label>
                                <p class="mt-1">R$ {{formatarValor(xmlSelecionado.cabecalho?.pis)}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-3">
                            <div class="field">
                                <label class="font-semibold text-sm">COFINS:</label>
                                <p class="mt-1">R$ {{formatarValor(xmlSelecionado.cabecalho?.cofins)}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-3">
                            <div class="field">
                                <label class="font-semibold text-sm">ICMS:</label>
                                <p class="mt-1">R$ {{formatarValor(xmlSelecionado.cabecalho?.icms)}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-3">
                            <div class="field">
                                <label class="font-semibold text-sm">II:</label>
                                <p class="mt-1">R$ {{formatarValor(xmlSelecionado.cabecalho?.ii)}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-3">
                            <div class="field">
                                <label class="font-semibold text-sm">Taxa Siscomex:</label>
                                <p class="mt-1">R$ {{formatarValor(xmlSelecionado.cabecalho?.taxaSiscomex)}}</p>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-3">
                            <div class="field">
                                <label class="font-semibold text-sm">Despesas Aduaneiras:</label>
                                <p class="mt-1">R$ {{formatarValor(xmlSelecionado.cabecalho?.despesasAduaneiras)}}</p>
                            </div>
                        </div>
                    </div>
                </p-card>
            </p-tabPanel>
            
            <!-- ABA 2: ITENS COM PESQUISA -->
            <p-tabPanel header="Itens ({{xmlSelecionado.itens.length}})" leftIcon="pi pi-list">
                <!-- Barra de Pesquisa -->
                <div class="mb-3">
                    <p-card>
                        <div class="flex gap-2 align-items-center">
                            <span class="p-input-icon-left flex-1">
                                <i class="pi pi-search"></i>
                                <input 
                                    type="text" 
                                    pInputText 
                                    [(ngModel)]="textoPesquisa"
                                    (input)="aplicarFiltro()"
                                    placeholder="Pesquisar por P/N, NCM, descrição..."
                                    class="w-full" />
                            </span>
                            
                            <button 
                                pButton 
                                type="button" 
                                icon="pi pi-times" 
                                (click)="limparPesquisa()"
                                [disabled]="!textoPesquisa"
                                class="p-button-outlined p-button-secondary"
                                pTooltip="Limpar pesquisa"
                                tooltipPosition="top"></button>
                            
                            <div class="flex align-items-center gap-2 px-3 py-2 surface-100 border-round">
                                <i class="pi pi-filter text-primary"></i>
                                <span class="font-semibold">
                                    {{itensFiltrados.length}} de {{xmlSelecionado.itens.length}} itens
                                </span>
                            </div>
                        </div>
                    </p-card>
                </div>
                
                <!-- Tabela de Itens -->
                <p-table [value]="itensFiltrados" 
                         [paginator]="true"
                         [rows]="10"
                         [rowsPerPageOptions]="[10,25,50,100]"
                         [scrollable]="true"
                         styleClass="p-datatable-sm p-datatable-striped">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 50px">#</th>
                            <th style="width: 150px">P/N</th>
                            <th style="width: 100px">NCM XML</th>
                            <th style="width: 100px">NCM Sistema</th>
                            <th>Descrição</th>
                            <th style="width: 80px" class="text-right">Qtd</th>
                            <th style="width: 100px" class="text-right">Valor Unit.</th>
                            <th style="width: 100px" class="text-center">Status</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>{{item.numeroItem}}</td>
                            <td><span class="font-mono font-semibold">{{item.pn}}</span></td>
                            <td><span class="font-mono">{{item.ncmXml}}</span></td>
                            <td>
                                <span class="font-mono"
                                      [ngClass]="{'text-red-600': item.ncmSistema === 'PN NÃO ENCONTRADO',
                                                  'text-orange-600': item.ncmDiferente && item.ncmSistema !== 'PN NÃO ENCONTRADO',
                                                  'text-green-600': !item.ncmDiferente}">
                                    {{item.ncmSistema}}
                                </span>
                            </td>
                            <td><span class="text-sm">{{item.descricao}}</span></td>
                            <td class="text-right">{{formatarValor(item.quantidade)}}</td>
                            <td class="text-right">$ {{formatarValor(item.valorUnitario)}}</td>
                            <td class="text-center">
                                <p-tag *ngIf="item.ncmSistema === 'PN NÃO ENCONTRADO'" 
                                       severity="danger" 
                                       value="NÃO ENCONTRADO"
                                       icon="pi pi-times-circle"></p-tag>
                                <p-tag *ngIf="item.ncmDiferente && item.ncmSistema !== 'PN NÃO ENCONTRADO'" 
                                       severity="warning" 
                                       value="DIFERENTE"
                                       icon="pi pi-exclamation-triangle"></p-tag>
                                <p-tag *ngIf="!item.ncmDiferente" 
                                       severity="success" 
                                       value="IGUAL"
                                       icon="pi pi-check-circle"></p-tag>
                            </td>
                        </tr>
                    </ng-template>
                    
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="8" class="text-center p-4">
                                <i class="pi pi-search text-4xl text-400 mb-3"></i>
                                <p class="text-500 m-0">
                                    Nenhum item encontrado com o termo "{{textoPesquisa}}"
                                </p>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>